import { useCallback, useContext, useMemo, useState } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { TableDataQa } from 'commons/types/enums'
import { Table } from 'ui/components'
import { CTRBatch } from '~bank-bsa-reporting/types/CTRBatches/CTRBatch'

import { CTRBatchesChosenItemsContext } from '../../context/CTRBatchesChosenItemsContext'
import { useCTRBatchDeleteConfirmation } from '../../hooks/useCTRBatchDeleteConfirmation'
import { columns } from './columns'
import { BatchView } from './components/BatchView'

const routeApi = getRouteApi('/_app/bsa/ctr-batch-list')

export const BSABatchesTable = () => {
  const navigate = routeApi.useNavigate()

  const { chosenItemsIdList, onToggleChooseItem, chooseSomeItems, resetChosenItemsList } =
    useContext(CTRBatchesChosenItemsContext)

  const items = routeApi.useLoaderData({ select: (s) => s?.items })
  const total = routeApi.useLoaderData({ select: (s) => s?.total })
  const { page, size } = routeApi.useSearch({ select: (s) => ({ page: s.page, size: s.size }) })
  const isFetching = routeApi.useMatch({ select: (s) => Boolean(s.isFetching) })

  const { handleDelete } = useCTRBatchDeleteConfirmation()

  const [modalItem, setModalItem] = useState<CTRBatch | null>(null)

  const isAllItemsChosen: boolean = useMemo(() => {
    let f = true
    for (const i of items) {
      const { id } = i
      if (!chosenItemsIdList?.includes(id)) {
        f = false
        break
      }
    }
    return f
  }, [chosenItemsIdList, items])

  const toggleAllItemsChosen = useCallback(() => {
    if (isAllItemsChosen && resetChosenItemsList) {
      resetChosenItemsList()
    } else if (chooseSomeItems) {
      chooseSomeItems(items)
    }
  }, [isAllItemsChosen, items, chooseSomeItems, resetChosenItemsList])

  return (
    <>
      {modalItem && <BatchView item={modalItem} onClose={() => setModalItem(null)} />}
      <Table
        loading={isFetching}
        dataQa={TableDataQa.BP_BATCH_LIST}
        dataSource={items.map((item) => ({ item }))}
        columns={columns({
          onShowBatch: setModalItem,
          chosenItemsIdList,
          isAllItemsChosen,
          onToggleChooseItem,
          toggleAllItemsChosen,
          handleDelete
        })}
        pagination={{
          page,
          size,
          onChange: (page, size) => {
            navigate({ to: '.', search: (prev) => ({ ...prev, page, size }), resetScroll: false })
          },
          total
        }}
      />
    </>
  )
}
